import { useCallback, useEffect, useRef, useState } from 'react';
import { linkedFormIDs, verifyElementDistribution, type DistributableElement } from '../utils/elementDistribution';

export function useElementDistribution(element: DistributableElement, paymentsReady: boolean, open = true) {
  const signature = JSON.stringify([element.elementID, element.elementType, element.QRCodeType, element.active, linkedFormIDs(element), paymentsReady]);
  const latest = useRef({ element, paymentsReady, signature });
  latest.current = { element, paymentsReady, signature };
  const [verified, setVerified] = useState<string | null>(null);
  const sequence = useRef(0);
  const refresh = useCallback(async () => {
    const request = ++sequence.current;
    const current = latest.current;
    const allowed = await verifyElementDistribution(current.element, current.paymentsReady);
    if (request !== sequence.current || current.signature !== latest.current.signature) return false;
    setVerified(allowed ? current.signature : null);
    return allowed;
  }, []);
  useEffect(() => {
    if (!open) return;
    void refresh();
    const onFocus = () => { void refresh(); };
    window.addEventListener('focus', onFocus);
    const timer = window.setInterval(onFocus, 10000);
    return () => {
      sequence.current++;
      window.removeEventListener('focus', onFocus);
      window.clearInterval(timer);
    };
  }, [signature, open, refresh]);
  return { canDistribute: verified === signature, refresh };
}
